import { azureADAuthorization } from "./azure-ad";
import { azureAuthorization } from "./azure";
import { localAuthorization } from "./local";
import { magicLinkAuthorization } from "./magicLink";
import { UserDetails } from "./userDetails/UserDetails";
const _ = {
  azureAuthorization,
  localAuthorization,
  UserDetails,
  magicLinkAuthorization,
  azureADAuthorization,
};
export default _;
